import React from 'react';

import Styled from './RunWorkflowModal.styled';

const {
  StyledFileRow,
  StyledFileName,
  StyledFileSize,
  StyledReselectLabel,
  StyledHiddenFileInput,
  StyledCloseIconButton,
} = Styled;

interface OwnProps {
  selectedFile: File | null;
  previousFileName: string | null;
  onFileChange: (file: File | null) => void;
}

const FilePicker = ({ selectedFile, previousFileName, onFileChange }: OwnProps) => {
  if (selectedFile) {
    return (
      <StyledFileRow $variant='selected'>
        <StyledFileName>{selectedFile.name}</StyledFileName>
        <StyledFileSize>{(selectedFile.size / 1024).toFixed(1)} KB</StyledFileSize>
        <StyledCloseIconButton
          type='button'
          onClick={() => onFileChange(null)}
          className='btn-ghost btn-sm'
          title='Remove file'
          aria-label='Remove file'
        >
          ✕
        </StyledCloseIconButton>
      </StyledFileRow>
    );
  }

  if (previousFileName) {
    return (
      <StyledFileRow
        $variant='previous'
        title='File was attached previously but lost when switching tabs — re-select it to keep it'
      >
        <StyledFileName>{previousFileName} (re-select to attach)</StyledFileName>
        <StyledCloseIconButton
          type='button'
          onClick={() => onFileChange(null)}
          className='btn-ghost btn-sm'
          title='Clear'
          aria-label='Clear file'
        >
          ✕
        </StyledCloseIconButton>
        <StyledReselectLabel>
          <StyledHiddenFileInput
            type='file'
            onChange={(e) => onFileChange(e.target.files?.[0] ?? null)}
          />
          Re-select
        </StyledReselectLabel>
      </StyledFileRow>
    );
  }

  return (
    <StyledFileRow as='label' $variant='empty'>
      <StyledHiddenFileInput
        type='file'
        onChange={(e) => onFileChange(e.target.files?.[0] ?? null)}
      />
      Choose file…
    </StyledFileRow>
  );
};

const MemoFilePicker = React.memo(FilePicker);

export { MemoFilePicker as FilePicker };
export default MemoFilePicker;
